var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_5058)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85601 0.654134C3.04601 -0.213866 4.28301 -0.219866 4.48101 0.647134L4.49101 0.691134L4.51101 0.777134C4.63179 1.29099 4.90091 1.75803 5.28494 2.12019C5.66897 2.48235 6.15096 2.72366 6.67101 2.81413C7.57601 2.97113 7.57601 4.27113 6.67101 4.42813C6.14803 4.5191 5.66359 4.76261 5.27857 5.12806C4.89355 5.49351 4.62512 5.9646 4.50701 6.48213L4.48101 6.59513C4.28301 7.46213 3.04701 7.45613 2.85601 6.58813L2.83601 6.49113C2.72229 5.97186 2.45648 5.49823 2.0725 5.13063C1.68851 4.76303 1.20375 4.51812 0.680014 4.42713C-0.223986 4.26913 -0.223986 2.97313 0.680014 2.81513C1.20175 2.72437 1.68483 2.48085 2.06809 2.11539C2.45135 1.74993 2.71756 1.27897 2.83301 0.762134L2.84901 0.691134L2.85601 0.654134ZM10.636 3.61613C10.9131 3.49979 11.2186 3.46934 11.5132 3.52871C11.8078 3.58808 12.0777 3.73455 12.288 3.94913L12.29 3.95013L13.556 5.22713C13.696 5.36651 13.8071 5.53216 13.8829 5.71458C13.9587 5.897 13.9977 6.09259 13.9977 6.29013C13.9977 6.48767 13.9587 6.68327 13.8829 6.86569C13.8071 7.04811 13.696 7.21376 13.556 7.35313L13.554 7.35513L7.35701 13.5921C7.27359 13.6762 7.16302 13.728 7.04501 13.7381L4.04501 13.9981C3.9724 14.0044 3.89929 13.9947 3.83082 13.9697C3.76234 13.9447 3.70016 13.9051 3.64862 13.8535C3.59708 13.802 3.55744 13.7398 3.53246 13.6713C3.50748 13.6029 3.49777 13.5298 3.50401 13.4571L3.76401 10.4571C3.77419 10.3391 3.82593 10.2286 3.91001 10.1451L10.147 3.94813C10.2861 3.80624 10.453 3.69339 10.636 3.61613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_5058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AiIcon.c77e5ff34c38319a4c2cc43205068f63.svg";
export { ForwardRef as ReactComponent };